<template>
	<div class="flex items-center">
		<input
			:id="props.id || defaultId"
			:name="props.id"
			type="checkbox"
			class="cursor-pointer appearance-none h-4 w-4 border shrink-0"
			:class="{
				'cursor-not-allowed': props.disabled,
				'border-red-600': props.error
			}"
			:checked="props.modelValue"
			:disabled="props.disabled"
			value="checkbox"
			@change="updateValue"
		/>
		<label
			v-if="props.content"
			:for="props.id || defaultId"
			class="pl-2 pr-4 cursor-pointer"
			:class="{
				'opacity-50': props.disabled,
				'text-red-600': props.error
			}"
			v-html="props.content"
		></label>
	</div>
</template>

<script setup lang="ts">
import { ref } from "vue";

interface Props {
	modelValue?: boolean;
	content?: string;
	id?: string;
	disabled?: boolean;
	error?: boolean;
}

const props = defineProps<Props>();

const emit = defineEmits(["update:modelValue"]);

const updateValue = (event: Event) => {
	const target = event.target as HTMLInputElement;
	emit("update:modelValue", target.checked);
};

const defaultId = ref(
	Math.random()
		.toString(36)
		.replace(/[^a-z]+/g, "")
		.substring(2, 10)
);
</script>
